"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getActivityId;
function getActivityId(activity) {
  return activity.id;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRBY3Rpdml0eUlkIiwiYWN0aXZpdHkiLCJpZCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy9BY3Rpdml0eUtleWVyL3ByaXZhdGUvZ2V0QWN0aXZpdHlJZC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFdlYkNoYXRBY3Rpdml0eSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRBY3Rpdml0eUlkKGFjdGl2aXR5OiBXZWJDaGF0QWN0aXZpdHkpOiBzdHJpbmcge1xuICByZXR1cm4gYWN0aXZpdHkuaWQ7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUVlLFNBQVNBLGFBQWFBLENBQUNDLFFBQXlCLEVBQVU7RUFDdkUsT0FBT0EsUUFBUSxDQUFDQyxFQUFFO0FBQ3BCIn0=